import { createSlice } from '@reduxjs/toolkit';

type CompanyType = {
  id: number;
  companyName: string;
  companySlug: string;
  companyImageUrl: string;
  companyLogo: string;
  prospectDriveFolderLink?: string;
  companySignatures?: {
    name: string;
    language: string;
    signature: string;
  }[];
  // Multi-domain "send from" options (only populated for the owner company).
  senderMailOptions?: {
    id: number;
    companyName: string;
    companyLogo?: string;
    fromEmail?: string;
  }[];
  aboutCompany: string;
  companyDescription: string;
  companyDetails: string;
  companyLocation: string;
  socialMediaLinks: string;
  timeZone: string;
  isActive: boolean;
  createdBy: string;
  updatedBy: string;
  deletedBy: string;
  createdAt: string;
  updatedAt: string;
};

interface InitialStateState {
  company: Partial<CompanyType>;
}

const initialState: InitialStateState = {
  company: {},
};

const slice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    companyFunction(state, action) {
      state.company = action.payload;
    },
  },
});

export default slice.reducer;
export const { companyFunction } = slice.actions;
